import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, errorText } from "@/lib/api";

const downloadCsv = (rows) => {
  const csv = ["email,joined", ...rows.map((r) => `${r.email},${r.created_at}`)].join("\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  a.download = "reader-list.csv";
  a.click();
};

const Messages = ({ items }) => (
  <div className="grid gap-4" data-testid="admin-messages-list">
    {items.length === 0 && <p>No messages yet.</p>}
    {items.map((m) => (
      <div key={m.id} className="border-2 border-ink bg-sand p-4">
        <p className="font-mono fr-lbl">{new Date(m.created_at).toLocaleString()}</p>
        <p className="font-bold mt-2">{m.name} {m.organisation && `· ${m.organisation}`} · <a className="underline" href={`mailto:${m.email}`}>{m.email}</a></p>
        <p className="mt-2 whitespace-pre-wrap">{m.message}</p>
      </div>
    ))}
  </div>
);

export default function Admin() {
  const [key, setKey] = useState("");
  const [data, setData] = useState(null);

  const load = async (e) => {
    e.preventDefault();
    try {
      const h = { headers: { "X-Admin-Key": key } };
      const [s, m] = await Promise.all([axios.get(`${API}/admin/subscribers`, h), axios.get(`${API}/admin/messages`, h)]);
      setData({ subs: s.data, msgs: m.data });
    } catch (err) {
      toast.error(errorText(err));
    }
  };

  return (
    <div className="min-h-screen bg-marigold text-ink px-6 py-16" data-testid="admin-page">
      <div className="max-w-4xl mx-auto">
        <p className="font-mono fr-lbl">families_reimagined / admin</p>
        <h1 className="font-mono font-bold fr-h2 mt-4">Reader list &amp; messages</h1>
        {!data ? (
          <form onSubmit={load} className="mt-8 max-w-md" data-testid="admin-key-form">
            <label className="font-mono fr-lbl">Admin key
              <input type="password" required value={key} onChange={(e) => setKey(e.target.value)} className="fr-field bg-sand" data-testid="admin-key-input" />
            </label>
            <button className="fr-btn mt-4 w-full py-4" data-testid="admin-key-submit">Open</button>
          </form>
        ) : (
          <div className="mt-8 grid gap-10">
            <div>
              <div className="flex items-center justify-between gap-4">
                <h2 className="font-mono font-bold text-xl" data-testid="admin-subscriber-count">{data.subs.length} readers</h2>
                <button onClick={() => downloadCsv(data.subs)} className="fr-btn px-4 py-2" data-testid="admin-export-csv-button">Download CSV</button>
              </div>
              <ul className="mt-4 border-2 border-ink bg-sand divide-y-2 divide-ink" data-testid="admin-subscribers-list">
                {data.subs.map((s) => (
                  <li key={s.id} className="px-4 py-2 flex justify-between gap-4"><span>{s.email}</span><span className="font-mono text-xs" data-testid={`admin-subscriber-welcome-${s.id}`}>{s.welcome_email ? `welcome ${s.welcome_email} / ` : ""}{new Date(s.created_at).toLocaleDateString()}</span></li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="font-mono font-bold text-xl mb-4">{data.msgs.length} messages</h2>
              <Messages items={data.msgs} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
